import { LoadingSkeleton } from "@/components/ui/loading-skeleton";

export function DashboardLoadingSkeleton() {
  return <LoadingSkeleton type="grid" itemCount={6} />;
}
